<div class="add-widget-container">
  <div class="add-widget-background"></div>
  <div class="add-widget-content">
    <h4 class="add-widget-text">
      {{ 'dashboard.cartridge.addWidget' | transloco }}
    </h4>
    <svg
      width="57"
      height="51"
      viewBox="0 0 57 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        class="add-widget-icon"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41.5833 6.49996H12.4167C9.19501 6.49996 6.58333 9.11163 6.58333 12.3333V35.6666C6.58333 38.8883 9.19501 41.5 12.4167 41.5H21.155L21.1667 41.4999C22.7775 41.4999 24.0833 42.8058 24.0833 44.4166C24.0833 46.0274 22.7775 47.3333 21.1667 47.3333H12.4167C5.97334 47.3333 0.75 42.1099 0.75 35.6666V12.3333C0.75 5.88997 5.97335 0.666626 12.4167 0.666626H41.5833C48.0267 0.666626 53.25 5.88997 53.25 12.3333V15.2499C53.25 16.8608 51.9442 18.1666 50.3333 18.1666C48.7225 18.1666 47.4167 16.8608 47.4167 15.2499V12.3333C47.4167 9.11163 44.805 6.49996 41.5833 6.49996ZM41.5833 21.0833C43.1942 21.0833 44.5 22.3891 44.5 23.9999V32.7499H53.25C54.8608 32.7499 56.1667 34.0558 56.1667 35.6666C56.1667 37.2774 54.8608 38.5833 53.25 38.5833H44.5V47.3333C44.5 48.9441 43.1942 50.2499 41.5833 50.2499C39.9725 50.2499 38.6667 48.9441 38.6667 47.3333V38.5833H29.9167C28.3058 38.5833 27 37.2774 27 35.6666C27 34.0558 28.3058 32.7499 29.9167 32.7499H38.6667V23.9999C38.6667 22.3891 39.9725 21.0833 41.5833 21.0833Z"
        fill="#ECEFF1"
      />
    </svg>
  </div>
</div>
